import { Controller } from '@hotwired/stimulus'
import SignaturePad from 'signature_pad'

const options = { penColor: 'rgb(59, 130, 246)' }

export default class extends Controller<HTMLFormElement> {
  static targets = ['canvas', 'signature']

  declare readonly canvasTarget: HTMLCanvasElement
  declare readonly signatureTarget: HTMLInputElement
  declare readonly hasCanvasTarget: boolean
  declare readonly hasSignatureTarget: boolean

  signaturePad: SignaturePad

  initialize (): void {
    if (this.hasCanvasTarget) {
      this.signaturePad = new SignaturePad(this.canvasTarget, options)
    }
  }

  submit ({ target }: { target: HTMLButtonElement }): void {
    target.disabled = true

    if (this.hasSignatureTarget) {
      if (this.signaturePad.isEmpty()) {
        target.disabled = false

        return alert('Please provide a signature.')
      }

      this.signatureTarget.value = this.signaturePad.toDataURL('image/png')
    }

    const event = new CustomEvent('project-transition-form:submit')
    target.dispatchEvent(event)
  }

  clear (): void {
    this.signaturePad.clear()
  }
}
